import {
  Issue,
  Shipment,
  TimeWindow,
  Waypoint,
  Action,
} from 'interfaces/journey';

export const getWaypointIssue = (waypoint: Waypoint) =>
  waypoint.actions?.flatMap((a) => a.issue).find(Boolean);

export const issueMinutes = (issue: Issue) =>
  issue.exceededBySeconds ? Math.ceil(issue.exceededBySeconds / 60) : undefined;

export const suggestedScheduleEnd = (schedule: TimeWindow, issue: Issue) => {
  if (!issue.exceededBySeconds) return schedule.to;
  const [h, m] = schedule.to.split(':').map(Number);
  const currentMinutes = h * 60 + m;
  const totalMinutes = Math.min(
    currentMinutes + Math.ceil(issue.exceededBySeconds / 60),
    23 * 60 + 59,
  );
  if (totalMinutes <= currentMinutes) return null;
  const newH = Math.floor(totalMinutes / 60);
  const newM = totalMinutes % 60;
  return `${String(newH).padStart(2, '0')}:${String(newM).padStart(2, '0')}`;
};

export interface FlaggedShipment {
  shipmentId: number;
  externalCode?: string;
  schedule?: TimeWindow;
  waypointAddress?: string;
  issue?: Issue;
}

export function buildShipmentsById(
  shipments?: Shipment[],
): Record<string, Shipment> {
  if (!shipments) return {};
  return shipments.reduce(
    (acc, shipment) => {
      acc[shipment.id] = shipment;
      return acc;
    },
    {} as Record<string, Shipment>,
  );
}

export function getFlaggedShipments(
  waypoints: Waypoint[] | undefined,
  shipmentsById: Record<string, Shipment>,
): FlaggedShipment[] {
  if (!waypoints) return [];

  return waypoints.flatMap(
    (waypoint) =>
      waypoint.actions?.flatMap((action) => {
        if (action.collectionId) return [];
        if (!action.routeShipmentId) return [];
        const shipment = shipmentsById[action.routeShipmentId];
        const issue = action.issue ?? shipment?.issue;
        if (!issue || issue.blame === 'data') return [];
        return [
          {
            shipmentId: action.routeShipmentId as number,
            externalCode: shipment?.externalCode,
            schedule: shipment?.schedule,
            waypointAddress: waypoint.address,
            issue,
          },
        ];
      }) ?? [],
  );
}
